import React from "react";
import { useTranslation } from "react-i18next";

import ChatTextarea from "../ChatTextarea/ChatTextarea";
import SendButton from "../SendButton/SendButton";

import "./FinderApp.scss";

const FinderApp = () => {
  const { t } = useTranslation("finderApp");

  return (
    <div className="finder-app">
      <div className="finder-app__header">
        <img src="/images/branding/finder-ai-logo.svg" alt={t("logoAltTxt")} width={180} height={29} />
        <h2 className="title">{t("title")}</h2>
        <p className="h3 subtitle white-3 loading-dots">{t("comingSoon")}</p>
      </div>

      <div className="finder-app__main">
        <ChatTextarea
          name="chatMessage"
          placeholder={t("inputs.chatMessage.placeholder")}
          maxRows={1}
          disabled
          adornments={<SendButton disabled />}
        />
      </div>

      <div className="finder-app__language-info">
        <img
          src="/images/layouts/finder-app/multi-language-icon.svg"
          alt={t("languageInfo.imgAltText")}
          width={68}
          height={68}
        />

        <p>{t("languageInfo.text")}</p>
      </div>
    </div>
  );
};

export default FinderApp;
